import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
function generateYears(year, noOfYear, minDate, maxDate) {
    const list = [];
    for(let i = 0; i < 2 * noOfYear + 1; i++){
        const newYear = year + noOfYear - i;
        let isInRange = true;
        if (minDate) {
            isInRange = minDate.year() <= newYear;
        }
        if (maxDate && isInRange) {
            isInRange = maxDate.year() >= newYear;
        }
        if (isInRange) {
            list.push(newYear);
        }
    }
    return list;
}
export default class YearDropdownOptions extends React.Component {
    constructor(props){
        super(props);
        const { yearDropdownItemNumber, scrollableYearDropdown } = props;
        const noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        this.state = {
            yearsList: generateYears(this.props.year, noOfYear, this.props.minDate, this.props.maxDate)
        };
    }
    renderOptions = ()=>{
        const selectedYear = this.props.year;
        const options = this.state.yearsList.map((year)=>/*#__PURE__*/ React.createElement("div", {
                className: selectedYear === year ? 'react-datepicker__year-option --selected_year' : 'react-datepicker__year-option',
                key: year,
                ref: year,
                onClick: this.onChange.bind(this, year)
            }, selectedYear === year ? /*#__PURE__*/ React.createElement("span", {
                className: "react-datepicker__year-option--selected"
            }, "✓") : '', year));
        const minYear = this.props.minDate ? this.props.minDate.year() : null;
        const maxYear = this.props.maxDate ? this.props.maxDate.year() : null;
        if (!maxYear || !this.state.yearsList.find((year)=>year === maxYear)) {
            options.unshift(/*#__PURE__*/ React.createElement("div", {
                className: "react-datepicker__year-option",
                ref: 'upcoming',
                key: 'upcoming',
                onClick: this.incrementYears
            }, /*#__PURE__*/ React.createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
        }
        if (!minYear || !this.state.yearsList.find((year)=>year === minYear)) {
            options.push(/*#__PURE__*/ React.createElement("div", {
                className: "react-datepicker__year-option",
                ref: 'previous',
                key: 'previous',
                onClick: this.decrementYears
            }, /*#__PURE__*/ React.createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
        }
        return options;
    };
    onChange = (year)=>{
        this.props.onChange(year);
    };
    handleClickOutside = ()=>{
        this.props.onCancel();
    };
    shiftYears = (amount)=>{
        const years = this.state.yearsList.map(function(year) {
            return year + amount;
        });
        this.setState({
            yearsList: years
        });
    };
    incrementYears = ()=>this.shiftYears(1);
    decrementYears = ()=>this.shiftYears(-1);
    render() {
        const dropdownClass = cx({
            'react-datepicker__year-dropdown': true,
            'react-datepicker__year-dropdown--scrollable': this.props.scrollableYearDropdown
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: dropdownClass
        }, this.renderOptions());
    }
}
YearDropdownOptions.propTypes = {
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    scrollableYearDropdown: PropTypes.bool,
    year: PropTypes.number.isRequired,
    yearDropdownItemNumber: PropTypes.number
};
